import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "page" }
const _hoisted_2 = { class: "top" }
const _hoisted_3 = { class: "top-wrapper" }
const _hoisted_4 = { class: "top-content" }
const _hoisted_5 = { class: "header" }
const _hoisted_6 = { class: "header-wrapper" }
const _hoisted_7 = { class: "header-content" }
const _hoisted_8 = { class: "body" }
const _hoisted_9 = { class: "body-wrapper" }
const _hoisted_10 = { class: "page-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MaintenanceBanner = _resolveComponent("MaintenanceBanner")!
  const _component_PageFooter = _resolveComponent("PageFooter")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_MaintenanceBanner),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _renderSlot(_ctx.$slots, "top-header", {}, undefined, true)
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _renderSlot(_ctx.$slots, "menu", {}, undefined, true)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _renderSlot(_ctx.$slots, "page-body", {}, undefined, true)
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_PageFooter)
      ])
    ])
  ]))
}